// sort-imports-ignore
/* eslint-disable import/first */
import { loadGMaps, newMap } from "tsi-common-react/src/utils/maps";
import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";
import iconMarker2 from "../../assets/img/retail-locator/icon-marker2.png";
import { t } from "ttag";

// Activate print button on Store page
(() => {
    const document = getDocument();
    if (!document) {
        return;
    }
    const window = getWindow();
    if (!window) {
        return;
    }
    document
        .querySelector<HTMLElement>("#print")
        ?.addEventListener("click", () => {
            window.print();
        });
})();

// Activate Google Map Hero on Store page
(async () => {
    const document = getDocument();
    if (!document) {
        return;
    }
    const window = getWindow();
    if (!window) {
        return;
    }
    const mapCanvas = document.querySelector<HTMLElement>("#map_canvas");
    if (!mapCanvas || !mapCanvas.dataset.lat || !mapCanvas.dataset.lng) {
        return;
    }
    // Load Google Maps API
    try {
        await loadGMaps();
    } catch (e) {
        console.warn("Google Maps failed to load", e);
        return;
    }
    // Init the map
    const storeLat = parseFloat(mapCanvas.dataset.lat);
    const storeLng = parseFloat(mapCanvas.dataset.lng);
    const myLatlng = new google.maps.LatLng(storeLat, storeLng);
    const mapCenter = new google.maps.LatLng(storeLat, storeLng);
    const mapOptions = {
        center: mapCenter,
        zoom: 16,
        scrollwheel: false,
        draggable: true,
        disableDefaultUI: false,
        clickableIcons: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    const map = newMap(mapCanvas, mapOptions);
    const marker = new google.maps.Marker({
        position: myLatlng,
        title: t`Tempur-Pedic Store`,
        icon: iconMarker2,
    });
    marker.setMap(map);
    map.set("styles", [
        {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
                { hue: "#ffff00" },
                { saturation: 30 },
                { lightness: 10 },
            ],
        },
    ]);
    // Handle title tag - a11y approved
    google.maps.event.addListenerOnce(map, "idle", () => {
        const mapDoc = getDocument();
        if (!mapDoc) {
            return;
        }
        const storeIframe =
            mapDoc.querySelector<HTMLIFrameElement>("#map_canvas iframe");
        if (storeIframe) {
            storeIframe.title = t`Google Maps`;
        }
    });
})().catch(console.error);

// Register store cascades
import "./cascades";
